module.exports = __webpack_public_path__ + "img/shanchu.b8f98596.svg";